import makeActionCreator from 'make-action-creator'

import { NAMESPACE } from './constants'

export const loginUser = makeActionCreator(NAMESPACE + '/loginUser')